module.exports = __webpack_public_path__ + "static/media/DESPAR.a06fcb07.svg";